export default "__VITE_ASSET__BxFWWvwe__"